import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

interface AAddProjectCardProps {
    onSelect: () => void;
}

const AddProjectCard: React.FC<AAddProjectCardProps> = ({ onSelect }) => {
    return (
        <div
            className="spec-card add"
            onClick={() => {
                onSelect();
            }}
        >
            <FontAwesomeIcon className="add-icon" icon={faPlus} />
            <p className="add-product">Create New Project</p>
        </div>
    );
};

export default AddProjectCard;
